<app-preview-layout>
    <ng-container previewTitle> {{ 'NEW_GROUP_OF_GROUPS' | translate | titlecase }}</ng-container>
    <ng-container backBtn *ngIf="!isOpenedInDrawer">
      <button class="round-btn btn-back" (click)="onBack()">
        <i class="ftmi-arrow-left"></i></button
    ></ng-container>

    <ng-container closeBtn *ngIf="isOpenedInDrawer">
      <button class="round-btn btn-back" (click)="onClose()">
        <i class="ftmi-cross"></i>
      </button>
    </ng-container>

    <ng-container previewContent>
      <form class="container" [formGroup]="form">
        <div class="white-panel preview-panel">
          <div class="row">
          <div [ngClass]="{ 'col-lg-12': isOpenedInDrawer, 'col-lg-6 pr-lg-3': !isOpenedInDrawer }">
              <div class="cord-label">
                <h3 class="label">{{ 'ROSTER_DETAILS' | translate }}</h3>
              </div>
              <app-roster-general-settings [form]="form"> </app-roster-general-settings>
            </div>
            <div [ngClass]="{ 'col-lg-12': isOpenedInDrawer, 'col-lg-6 pr-lg-3': !isOpenedInDrawer }">
              <app-roster-group-upload [form]="form"></app-roster-group-upload>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  
    <ng-container footerContent>
      <button type="button" class="btn btn-padded btn-radius btn-outline-primary mx-2" (click)="onBack()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-primary btn-padded btn-radius mx-2" (click)="onSubmit()">
        {{ 'ADD' | translate }}
      </button>
    </ng-container>
  </app-preview-layout>
